export enum SSE_EVENT_TYPES {
  HUBSPOT_APPLICANT_CREATED = "hubspot_applicant_created"
}
